import React from 'react';
import {formatStoreProductCardHeading, type StoreProductCardHeadingFields} from './format-store-product-card-heading';

export function StoreProductCardHeading({instName, productName, gradSchoolId, gsName}: StoreProductCardHeadingFields) {
    return <h2 className="name">{formatStoreProductCardHeading({instName, productName, gradSchoolId, gsName})}</h2>;
}
